import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.379 3.15a.48.48 0 0 0-.7 0l-.53.53a.48.48 0 0 0 0 .7L5.748 7a9.66 9.66 0 0 0-3.688 4.68A1 1 0 0 0 2 12q0 .161.06.31A10.64 10.64 0 0 0 11.994 19a10.8 10.8 0 0 0 4.667-1.09l2.948 2.94a.48.48 0 0 0 .7 0l.53-.53a.48.48 0 0 0 0-.7zM11.994 17a8.81 8.81 0 0 1-7.925-5 8.1 8.1 0 0 1 3.128-3.56l2.159 2.16a3 3 0 0 0 .585 3.414 3 3 0 0 0 3.412.586l1.759 1.76a9 9 0 0 1-3.118.64M9.116 5.4a10.7 10.7 0 0 1 12.872 6.3q.024.15 0 .3a.8.8 0 0 1-.06.33 9.1 9.1 0 0 1-2.329 3.56l-1.419-1.42A7.3 7.3 0 0 0 19.92 12a8.81 8.81 0 0 0-7.926-5q-.598 0-1.19.09z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }